var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kus-base-date-range-field',{attrs:{"input-class":"py-0 pr-3","label":_vm.$t('vat.dateLabel'),"disabled":_vm.disabled,"hide-details":""},on:{"input":_vm.change},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})
}
var staticRenderFns = []

export { render, staticRenderFns }